// extracted by mini-css-extract-plugin
export default {"grid":"TwitterFeed_grid__ziB5p","column":"TwitterFeed_column__e+CCy"};